import React, { memo, useCallback, useEffect, useState } from 'react'
import { Button, Space, Transfer } from 'antd'
import { PlayerToTeam } from 'types/players-to-teams'
import { TransferDirection } from 'antd/es/transfer'
import { Roster } from 'types/roster'

type Props = {
    roster: Roster[]
    players: PlayerToTeam[]
    submitRoster: (addKeys: string[], deleteKeys: string[]) => void
}

export const RosterTransfer = memo((props: Props) => {
    const { players, roster, submitRoster } = props

    const [targetKeys, setTargetKeys] = useState<string[]>([])
    const [selectedKeys, setSelectedKeys] = useState<string[]>([])

    useEffect(() => {
        setTargetKeys(roster.map(it => it.playerId.toString()))
    }, [roster])

    const onChange = useCallback((nextTargetKeys: string[], direction: TransferDirection, moveKeys: string[]) => {
        setTargetKeys(nextTargetKeys)
    }, [])

    const onSelectChange = useCallback((sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
    }, [])

    const handleSaveRoster = useCallback(async () => {
        const targetKeysMap = targetKeys.reduce((acc, it) => {
            acc[it] = true
            return acc
        }, {} as Record<string, boolean>)

        const deleteRosterKeys = roster.reduce((acc, it) => {
            if (targetKeysMap[it.playerId]) {
                delete targetKeysMap[it.playerId]
            } else {
                acc.push(it.id.toString())
            }

            return acc
        }, [] as string[])

        const addPlayerKeys = Object.keys(targetKeysMap)

        submitRoster(addPlayerKeys, deleteRosterKeys)
    }, [roster, submitRoster, targetKeys])

    return (
        <Space direction={'vertical'} size={'large'}>
            <Transfer
                dataSource={players}
                targetKeys={targetKeys}
                selectedKeys={selectedKeys}
                onChange={onChange}
                onSelectChange={onSelectChange}
                rowKey={record => record.playerId.toString()}
                render={item => `${item.player?.name} ${item.player?.surname}`}
                listStyle={{ minWidth: '300px' }}
            />
            <Button type={'primary'} onClick={handleSaveRoster}>
                Save
            </Button>
        </Space>
    )
})
